import React from 'react'
import { Logo } from '@/components/frontend/atoms/navigation/Logo'
import { ButtonLink } from '@/components/frontend/atoms/navigation/ButtonLink'
import { MobileMenuButton } from '@/components/frontend/atoms/navigation/MobileMenuButton'
import { MobileMenuOverlay } from '@/components/frontend/atoms/navigation/MobileMenuOverlay'
import { LanguageSwitcher } from '@/components/frontend/atoms/navigation/LanguageSwitcher'
import { NavbarShell, NavbarCtaDesktop } from '@/components/frontend/atoms/navigation/NavbarShell'
import { Inline } from '@/components/shared/atoms/layout/Inline'
import { NavMenu } from '@/components/frontend/molecules/NavMenu'
import { MobileNavMenu } from '@/components/frontend/molecules/MobileNavMenu'
import { useSiteNavbarVM } from './SiteNavbar.vm'

export const SiteNavbar: React.FC = () => {
  const {
    navItems, currentPath, mobileOpen, toggleMobile, closeMobile,
    locale, locales, switchLocale, t, lp,
  } = useSiteNavbarVM()

  const settings = <LanguageSwitcher currentLocale={locale} locales={locales} onSwitch={switchLocale} />

  return (
    <>
      <NavbarShell
        start={<Logo />}
        center={<NavMenu items={navItems} currentPath={currentPath} />}
        end={
          <>
            {settings}
            <NavbarCtaDesktop>
              <ButtonLink href={lp('/#contatti')} size="sm">{t('nav.book_call')}</ButtonLink>
            </NavbarCtaDesktop>
            <MobileMenuButton
              isOpen={mobileOpen}
              onToggle={toggleMobile}
              label={mobileOpen ? t('nav.close_menu') : t('nav.open_menu')}
            />
          </>
        }
      />
      <MobileMenuOverlay isOpen={mobileOpen} onClose={closeMobile} closeLabel={t('nav.close_menu')} logo={<Logo />}>
        <MobileNavMenu items={navItems} currentPath={currentPath} onNavigate={closeMobile} />
        <Inline gap="2">{settings}</Inline>
        <ButtonLink href={lp('/#contatti')} size="lg" arrow>{t('nav.book_call')}</ButtonLink>
      </MobileMenuOverlay>
    </>
  )
}
